import { Card, CardContent, Typography, Box, Skeleton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

const DashboardStatCard = ({ title, value, subtext, trend, color = '#1976d2', icon, isLoading, to }) => {
    const navigate = useNavigate();
    return (
        <Card
            onClick={() => to && navigate(to)}
            sx={{
                borderRadius: 3,
                height: '100%',
                borderLeft: `5px solid ${color}`,
                boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                cursor: to ? 'pointer' : 'default',
                transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                '&:hover': to
                    ? {
                          transform: 'translateY(-4px)',
                          boxShadow: '0 8px 30px rgba(0,0,0,0.1)'
                      }
                    : {}
            }}
        >
            <CardContent>
                {isLoading ? (
                    <>
                        <Skeleton width="60%" height={24} sx={{ mb: 1 }} />
                        <Skeleton width="80%" height={40} />
                    </>
                ) : (
                    <>
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                            <Typography variant="body2" color="text.secondary" fontWeight={600} textTransform="uppercase">
                                {title}
                            </Typography>
                            {icon && <Box sx={{ color: color, opacity: 0.8 }}>{icon}</Box>}
                        </Box>
                        <Box display="flex" alignItems="baseline" gap={1}>
                            <Typography variant="h4" fontWeight={700} color="text.primary">
                                {value}
                            </Typography>
                            {trend && (
                                <Typography
                                    variant="caption"
                                    color="success.main"
                                    bgcolor="#e8f5e9"
                                    px={0.8}
                                    py={0.2}
                                    borderRadius={1}
                                    fontWeight={600}
                                >
                                    {trend}
                                </Typography>
                            )}
                        </Box>
                        {subtext && (
                            <Typography variant="caption" color="text.secondary" mt={0.5} display="block">
                                {subtext}
                            </Typography>
                        )}
                    </>
                )}
            </CardContent>
        </Card>
    );
};

DashboardStatCard.propTypes = {
    title: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    subtext: PropTypes.string,
    trend: PropTypes.string,
    color: PropTypes.string,
    icon: PropTypes.node,
    isLoading: PropTypes.bool,
    to: PropTypes.string
};

export default DashboardStatCard;
